export default "__VITE_ASSET__IG43XPvo__"